import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import Layout from './layout';

/* eslint-disable */
if (allData.params.name !== '0') {
    allData.name = allData.params.name;
} else {
    allData.name = '';
}

ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
